import {
  FETCH_PURCHASE_ORDER_LIST,
  RESET_PURCHASE_ORDER_LIST,
} from "../../constants/action.constants";

//Storage for data.
const initialState = {
  list: [],
  others: {
    total: 0,
    offset: 0,
    limit: 20,
  },
};

//Controller for the storage.
const purchaseOrderListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PURCHASE_ORDER_LIST:
      return { list: action.payload, others: action.others };
    case RESET_PURCHASE_ORDER_LIST:
      return initialState;
    default:
      return state;
  }
};

export default purchaseOrderListReducer;
